import React from 'react';
import classNames from 'classnames';
import { useTrackFocus } from './hooks/useTrackFocus';
import './RangeSlider.less';
import { useTabbingContext } from 'contexts/TabbingContext';

export interface IRangeSliderProps {
  className?: string;
  id: string;
  min: number;
  max: number;
  value?: number;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  tabIndex?: number;
  step?: number;
  style?: React.CSSProperties;
}

const getClassName = (isFocused: boolean, className?: string) => classNames('dpc-range-slider', className, {});

/**
 * A basic, HTML 5 range input, with our styling.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export const RangeSlider = React.forwardRef(({ className, id, max, min, onChange, step, tabIndex, value, style }: IRangeSliderProps, ref: React.Ref<HTMLInputElement>) => {
  const { isFocused, focusTrackingProps } = useTrackFocus();
  tabIndex = useTabbingContext(tabIndex);
  // TODO - do we _need_ focus tracking for this, or will the :focus selectors be adequate?
  return (
    <input
      ref={ref}
      id={id}
      className={getClassName(isFocused, className)}
      type="range"
      min={min}
      style={style}
      max={max}
      step={step}
      value={value}
      onChange={onChange}
      {...focusTrackingProps}
      tabIndex={tabIndex}
    />
  );
})
